import React, {Component} from "react";
import items from "./data.js";
const RoomContext = React.createContext();

class RoomProvider extends Component{
    state = {
        items: [],
        sortedRooms: [],
        featuredRooms: [],
        favRooms: [],
        cartRooms:[],
        loading: true,
        type: "all",
        capacity: 1,
        price: 0,
        maxPrice: 0,
        minPrice: 0,
        maxSize: 0,
        minSize: 0,
        tax: 20,
        breakfast: false,
        pets: false,
        notificationMSG: {message: "hello", mode:"success"},
        showNotification: false,
        total: 0,
    };
    componentDidMount(){
        let rooms = this.formatData(items);
        // console.log(rooms, this.state.featuredRooms);
        let FTRooms = rooms.filter(room => room.featured === true); //Filters rooms to extact the featured ones
        let maxPrice = Math.max(...rooms.map(item => item.price)); //extracts the highest price room from the data
        let maxSize = Math.max(...rooms.map(item => item.size));    //extracts the largest size room from the data
        this.setState(prevState=>({
            ...prevState,
            items: rooms,
            sortedRooms: rooms,
            featuredRooms: FTRooms,
            loading: false,
            price:maxPrice,
            maxPrice,
            maxSize
        }));
    }
    componentDidUpdate=((prevProps,prevState)=>{
        if(this.state.items !== prevState.items){
            const favCopy = this.state.items.filter(item => item.liked);
            const cartCopy = this.state.items.filter(item => item.reserved);
            this.setState({
                favRooms: favCopy,
                cartRooms: cartCopy
            });
        }
        if(this.state.cartRooms !== prevState.cartRooms){
            this.equalizingValues();
        }
    });
    handleChanges= event =>{
        const name = event.target.name;
        const target = event.target;
        const value = target.type === "checkbox" ?
        target.checked : target.value;
        this.setState({
            [name]: value
        },this.filterRooms); //also triggers filterRooms as a callback function with every input change
    }
    addARoom = (location, id)=>{
        var sortedRoomsIndex;
        this.state.items.find((item, i) =>{
            sortedRoomsIndex = i;
           return item.id === id;
        });

        // if(location === "favRooms"){
                
                // let checkFeatRooms = this.state.featuredRooms.find((item, i) =>{
                //     featuredRoomsIndex = i;
                //     return item.id === id;
                // });
            let sortedRoomsCopy = JSON.parse(JSON.stringify(this.state.items));
            let currentType;
            location === "favRooms" ? currentType = "liked" :currentType = "reserved";
            sortedRoomsCopy[sortedRoomsIndex][currentType] = !this.state.items.find(item => item.id === id)[currentType];

            if( this.state.items.find(item => item.id === id)[currentType]){
                this.notification(`Item removed from ${location === "favRooms" ? "favorites.":"reservation box."}`,"warning"); 
            }else{
                this.notification(`Item added to ${location === "favRooms" ? "favorites.":"reservation box."}`,"success"); 
            }
            // if(checkFeatRooms){
            //     let featuredRoomsCopy = JSON.parse(JSON.stringify(this.state.items));
            //     featuredRoomsCopy[featuredRoomsIndex][currentType] = !this.state.items.find(item => item.id === id)[currentType];
            //     this.setState({
            //         cartRooms: sortedRoomsCopy.filter(item => item.reserved),
            //         favRooms: sortedRoomsCopy.filter(item => item.liked),
            //         // featuredRooms: featuredRoomsCopy
            //     })
            // }
            this.setState({
                items: sortedRoomsCopy,
                cartRooms: sortedRoomsCopy.filter(item => item.reserved),
                favCopy: sortedRoomsCopy.filter(item => item.liked),
                // sortedRooms: sortedRoomsCopy
            })
        // }
        // if(location === "cartRooms"){
            // let newSortedCopy = JSON.parse(JSON.stringify(this.state.sortedRooms));
            // newSortedCopy[sortedRoomsIndex].reserved = !this.state.sortedRooms.find(item => item.id === id).reserved;
            // let newCartCopy = newSortedCopy.filter(item => item.reserved);
            // this.setState({
            //     cartRooms: newCartCopy,
            //     sortedRooms: newSortedCopy
            // });
            // console.log(newSortedCopy[sortedRoomsIndex], sortedRoomsIndex);
            // this.notification(`Added to ${location === "favRooms" ?"favorites.":"reservation box."}`,"success"); 
        // }
        
        
        // setTimeout(()=>{
        //     this.setState({//clears any repeated elements from the array (if the user clicks on an item multiple times)
        //         [location]: [...new Set(this.state[location])] 
        //     })
        // },500);

        
    }
    deleteRoom= (type,id ,index) => {
        var sortedRoomsIndex;
          this.state.items.find((item, i)=>{
              sortedRoomsIndex = i
              return item.id === id
          });
          
        //toggle item's value
        if(type === "favRooms"){
          
            let updatedItems = JSON.parse(JSON.stringify(this.state.items)) ;
            updatedItems[sortedRoomsIndex].liked = false;
            
            this.setState({
                items: updatedItems,
            });
            }
        if(type === "cartRooms"){
            let updatedItems = JSON.parse(JSON.stringify(this.state.items)) ;
                updatedItems[sortedRoomsIndex].reserved = false;
            this.setState({
                items: updatedItems
            });
        }
        
        //delete item
        let itemsAfterDeletion = this.state[type].splice(index,1);
        this.setState({
            [type]: itemsAfterDeletion
        });
    }
    filterRooms= ()=>{
        let {  //destructuring elements from the state object
            items,
            type,
            capacity,
            pets,
            breakfast,
            maxPrice,
            minPrice,
            maxSize,
            minSize,
            price
        } = this.state;
        
        let tempRooms = [...items];
            // console.log(tempRooms);
        // let mappedRooms = tempRooms.map(item =>{
        //     return item.fields;
        // });
        capacity = parseInt(capacity); //converts it into a number value
        price = parseInt(price);

        //filter by type
        if( type !== "all"){ //only filters then any other option than "all" is selected otherwise all elements will be normally included
            tempRooms = tempRooms.filter(room => {
                return room.type === type //returns only rooms that matches the seleted type
            });
        }
        //filter by the capacity
        if(capacity !== 1){
            tempRooms = tempRooms.filter(room =>{
            return room.capacity >= capacity;
        })
        }
        //filter by room price
        if(price > minPrice && price < maxPrice){
            tempRooms = tempRooms.filter(room => room.price <= price)
        }
        //filter by the size
            tempRooms = tempRooms.filter(room => room.size >= minSize && room.size <= maxSize);
        //filter by pets
        if(pets){
            tempRooms = tempRooms.filter(room => room.pets === true);
        }
        //filter by breakfast
        if(breakfast){
            tempRooms = tempRooms.filter(room => room.breakfast === true);
        }

        //Change state
        this.setState({ //sortedRooms array will be adjusted according to the filter
            sortedRooms: tempRooms
        });
    }
    
    formatData(items){
        let tempData = items.map((item, index) =>{
            let id = item.sys.id;
            let images = item.fields.images.map(image=> image.fields.file.url);
                let room = {
                    ...item.fields,
                    images: images, //overrides the original images property
                    id: id // you could also type them like this let room = {...item.fields, images, id}
                }
                return room; //returns room
            })
            return tempData; //returns tempData
    }

    getRoom = slug => { //gets the specific room that is being clicked on
        // console.log(this.state.items)
        let tempRoom = [...this.state.items]; 
       const selectedRoom = tempRoom.find(item => item.slug === slug);
       return selectedRoom;
    }
    notification = (message ,mode)=>{
        this.setState({
            showNotification: true,
            notificationMSG: {message:message, mode:mode}
        })
        let timeout = setTimeout(()=>{
           this.setState({
                showNotification: false,
               notificationMSG: {message: "", mode: ""}
           }) 
           clearTimeout(timeout);
        },3000);
    }
    equalizingValues=()=>{
        if(this.state.cartRooms.length > 1){
            let getSum = this.state.cartRooms.map(el => el.price);
            let result = getSum.reduce((accumulator , current)=>{
                return accumulator + current;
            })
            this.setState({
                total: result
            });            
        }
        
    }
    clearCart=(location)=>{//turns all reserved items in "Items" into false
        var copyItems = JSON.parse(JSON.stringify(this.state.items));
        if(location === "cart"){
            for(var i=0; i< copyItems.length; i++){ 
                copyItems[i].reserved = false;
            }
            this.setState({//deletes all items in the cartRoom array
                cartRooms: [],
                items: copyItems,
                total: 0
            });
            this.notification("Reservations box was cleared", "warning");
        }else if(location === "favorites"){
            for(let j=0; j< copyItems.length; j++){ 
                copyItems[j].liked = false;
            }
            this.setState({//deletes all items in the cartRoom array
                favRooms: [],
                items: copyItems
            }); 
            this.notification("Favorites box was cleared", "warning");
        }
        
    }
    handleTotal = (val,id) =>{
        let itemsIndex;
        this.state.cartRooms.find((item,index) =>{
            itemsIndex = index;
            return item.id === id;
        });
        let itemsCopy = JSON.parse(JSON.stringify(this.state.cartRooms));
        itemsCopy[itemsIndex].priceAfterAlteration = val;
        this.setState({
            cartRooms: itemsCopy
        });
        let getSum = this.state.cartRooms.map(el => el.priceAfterAlteration);
        let result = getSum.reduce((accumulator , current)=>{
            return accumulator + current;
        })
        this.setState({
            total: result
        });
        // let tempIds = [];
        // this.state.totalIds.push(id);
        // this.setState({
        //     totalIds:
        // });
        // let tempTotalIds = [...new Set(this.state.totalIds)];
        // console.log(tempTotalIds);
       
        // let matchedIds = this.state.items.find(item => item.id === tempTotalId[i]);
        // tempIds = [...new Set([this.state.total.map(item => item[])])];
        // var test = [];
        // for(let i = 0; i<tempTotalIds.length;i++){
        //     var individualIds =  tempTotalIds[i];
        //     console.log(test, tempTotalIds[i]);
        //    for(const key in this.state.total){
               
        //     //    var newTest = [...new Set(test)];
        //        test.push(this.state.total[key]);
                
        //     };
            
        // }
        // this.state.total.unshift(val);
        //  console.log(this.state.total,tempTotalIds);
    }
    render(){
        
        return( //passes the altered state to other components
           <RoomContext.Provider
           value={{
               ...this.state,
               getRoom: this.getRoom,
               handleChanges: this.handleChanges,
               addToCart: this.addARoom,
               handleTotal: this.handleTotal,
               notification: this.notification,
               notificationMSG: this.state.notificationMSG,
               showNotification: this.state.showNotification,
               equalizingValues: this.equalizingValues,
               deleteRoom: this.deleteRoom,
               clearCart: this.clearCart
               }}>  
                {this.props.children} 
            </RoomContext.Provider>
        )
    }
}
const RoomConsumer = RoomContext.Consumer;
export{
    RoomProvider,
    RoomContext,
    RoomConsumer
}